import {
  ApiResponse,
  ENDPOINTS,
  HTTP_STATUS,
  apiInstance,
  isApiError,
} from '@/shared/api';
import { GetUserProfileResponse } from '@/shared/api';

export type UserProfile = {
  name: string;
  email: string;
  username: string;
  createdAt: string;
  updatedAt: string;
};

export const getUserProfile = async (): Promise<UserProfile | null> => {
  try {
    const data = await apiInstance.get<GetUserProfileResponse>(
      ENDPOINTS.user(),
    );

    if (!data) return null;

    return {
      name: data.name,
      email: data.email,
      username: data.username,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    };
  } catch (err) {
    // 401은 "비로그인" 정상 응답이지 에러가 아님.
    // null로 변환해서 useQuery의 error 경로를 타지 않게 한다.
    // (다른 status는 그대로 throw해서 기존 에러 처리 플로우를 유지)
    if (isApiError(err) && err.status === HTTP_STATUS.UNAUTHORIZED) {
      return null;
    }
    throw err;
  }
};

export const getOnboardingStatus = async () => {
  const res = await apiInstance.get<ApiResponse<{ is_first: boolean }>>(
    ENDPOINTS.onboarding(),
  );
  if (!res.data) throw new Error('Failed to get onboarding status');
  return res.data;
};
